/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KaikonZyutyuHaisyaPatternService from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/kaikonZyutyuHaisyaPatternService"
import {
  TKaikonZyutyuHaisyaPatternListGetReq,
  TKaikonZyutyuHaisyaPatternListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  PICKBindings,
  その他Bindings,
  オーダー情報Bindings,
  コンテナ情報Bindings,
  作業Bindings,
  支払Bindings,
  荷主Bindings,
  請求Bindings,
  返却Bindings,
} from "./KaikonZyutyuHaisyaPattenListConstant"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"
import ComboBox from "../../../components/ComboBox"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import BusyoService from "../../../service/master/busyo/busyoService"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { RootState } from "../../../globalStore/rootreducer"
import KubunService from "../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"

/**
 * 海コン受注配車パターン一覧
 * @returns
 */
const KaikonZyutyuHaisyPatternList = () => {
  const history = useHistory()
  const location = useLocation()

  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )

  //TODO:ページ名称確定必須
  let gridId = "KaikonZyutyuHaisyPatternList_GridId"

  //#region [method]

  /**
   *
   * @param 荷主コード
   * @returns
   */
  const set表紙 = async (荷主コード: string) => {
    try {
      if (荷主コード == null || 荷主コード === "") {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主res = await new NinusiService().getList({
        荷主コード: 荷主コード !== "" ? 荷主コード : undefined,
        完全一致フラグ: true,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
        return
      }
      const 荷主 = 荷主res.data[0]
      set荷主コード(荷主.荷主コード)
      set荷主略称1(荷主.荷主略称1)
      if (荷主 != null) {
        const ninusiSeikyuService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiSeikyuService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res && 荷主請求res.data.length > 0) {
          set表紙分割ItemSource([...荷主請求res.data])
          set請求内訳ItemSource([])
        } else {
          set表紙分割ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set表紙分割ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  /**
   * ページ初期状態でクエリに表紙名もしくは荷主請求内訳があった時に一覧を取得します。
   */
  const setInit荷主請求内訳 = async () => {
    if (location.search == null || location.search === "") return

    const query: Partial<TKaikonZyutyuHaisyaPatternListGetReq> =
      queryString.parse(location.search)
    if (query == null) return

    // 表紙名と請求内訳からlistを取得し、埋め込む
    if (query.荷主コード) {
      const 表紙分割Res = await new NinusiSeikyuService().getList({
        荷主コード: query.荷主コード,
      })

      if (表紙分割Res.data && 表紙分割Res.data.length > 0) {
        set表紙分割ItemSource([...表紙分割Res.data])
      }
    }
    if (query.荷主請求ID) {
      const 荷主請求内訳Res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求Id: query.荷主請求ID,
      })
      if (荷主請求内訳Res.data && 荷主請求内訳Res.data.length > 0) {
        set請求内訳ItemSource([...荷主請求内訳Res.data])
      }
    }
  }

  const restoreSearch = async () => {
    let querySearchCondition: TKaikonZyutyuHaisyaPatternListGetReq | undefined =
      undefined

    // 遷移してきた際のクエリパラメータで検索条件を生成
    querySearchCondition = await queryParse()
    // 再検索
    await search(querySearchCondition)

    dispatch(画面ロック解除())

    // リストア中フラグON
    setIsRestoreSearching(true)
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (
    searchCondition?: TKaikonZyutyuHaisyaPatternListGetReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TKaikonZyutyuHaisyaPatternListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new KaikonZyutyuHaisyaPatternService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = async () => {
    const query: TKaikonZyutyuHaisyaPatternListGetReq = queryString.parse(
      location.search
    )
    set受注部所コード(query.受注部所コード ?? userInfo.部所コード ?? "")
    set荷主コード(query.荷主コード)
    set荷主略称1(query.荷主略称1)

    const query荷主請求ID = query?.荷主請求ID?.toString() ?? ("" as string)
    query荷主請求ID !== "" && set荷主請求ID(parseInt(query荷主請求ID))
    const query荷主請求内訳ID =
      query?.荷主請求内訳ID?.toString() ?? ("" as string)
    query荷主請求内訳ID !== "" &&
      set荷主請求内訳ID(parseInt(query荷主請求内訳ID))

    set受注配車パターンコード(query.受注配車パターンコード)
    set社名(query.社名)
    set地名(query.地名)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TKaikonZyutyuHaisyaPatternListGetReq => {
    return {
      受注部所コード: 受注部所コード ?? "",
      荷主コード,
      荷主略称1: 荷主略称1,
      荷主請求ID:
        荷主請求ID != null && 荷主請求ID !== 0 ? 荷主請求ID : undefined,
      荷主請求内訳ID:
        荷主請求内訳ID != null && 荷主請求内訳ID !== 0
          ? 荷主請求内訳ID
          : undefined,
      受注配車パターンコード,
      社名,
      地名,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TKaikonZyutyuHaisyaPatternListGetReq
  ) => {
    return {
      受注部所コード,
      荷主コード: wjCore.isNullOrWhiteSpace(searchCondition.荷主コード ?? "")
        ? ""
        : searchCondition.荷主コード,
      荷主名: 荷主略称1,
      表紙名: 表紙分割ItemSource?.find(
        (i) =>
          i.荷主請求ID.toString() === searchCondition?.荷主請求ID?.toString()
      )?.表紙名,
      請求内訳: 請求内訳ItemSource?.find(
        (i) =>
          i.荷主請求内訳ID.toString() ===
          searchCondition?.荷主請求内訳ID?.toString()
      )?.請求内訳名,
      受注配車パターンコード,
      社名,
      地名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set受注部所コード("")
    set荷主コード("")
    set荷主略称1("")
    set荷主請求ID(undefined)
    set荷主請求内訳ID(undefined)
    set受注配車パターンコード("")
    set社名("")
    set地名("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (荷主Bindings.includes(c.binding)) {
          setHeaderText = "荷主"
        } else if (コンテナ情報Bindings.includes(c.binding)) {
          setHeaderText = "コンテナ情報"
        } else if (オーダー情報Bindings.includes(c.binding)) {
          setHeaderText = "オーダー情報"
        } else if (PICKBindings.includes(c.binding)) {
          setHeaderText = "PICK"
        } else if (作業Bindings.includes(c.binding)) {
          setHeaderText = "作業"
        } else if (返却Bindings.includes(c.binding)) {
          setHeaderText = "返却"
        } else if (その他Bindings.includes(c.binding)) {
          setHeaderText = "その他"
        } else if (請求Bindings.includes(c.binding)) {
          setHeaderText = "請求"
        } else if (支払Bindings.includes(c.binding)) {
          setHeaderText = "支払"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }
  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [荷主コード, set荷主コード] = useState<string>()
  const [受注配車パターンコード, set受注配車パターンコード] = useState<string>()
  const [荷主略称1, set荷主略称1] = useState<string>()
  const [地名, set地名] = useState<string>()
  const [社名, set社名] = useState<string>()
  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const [表紙分割ItemSource, set表紙分割ItemSource] = useState<T表紙分割[]>()

  const [荷主請求内訳ID, set荷主請求内訳ID] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [運行部所DataMap, set運行部所DataMap] =
    useState<wjGrid.DataMap<T部所マスタ>>()
  const [税込区分DataMap, set税込区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()
  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjGrid.DataMap<T区分マスタ>>()
  //#endregion

  //#region comboboxState
  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)
  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)
  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  const [comboBoxDataInitialized, setComboBoxDataInitialized] = useState(false)

  //#endregion

  //#region [effect]
  //初期表示
  useEffect(() => {
    //区分値の確保
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      setInit荷主請求内訳(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set税込区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.税込区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set課税区分DataMap(
        new wjGrid.DataMap(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
      if (部所ListRes) {
        set部所ItemSource(部所ListRes.data)
        set運行部所DataMap(
          new wjGrid.DataMap(
            部所ListRes.data.filter((d) => d.運行部所フラグ === 1),
            "部所コード",
            "部所略称"
          )
        )
      }
      setComboBoxDataInitialized(true)
    })
  }, [])
  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 受注部所isLoadEnded && comboBoxDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        restoreSearch()
      } else {
        set受注部所コード(userInfo.部所コード)

        let querySearchCondition:
          | TKaikonZyutyuHaisyaPatternListGetReq
          | undefined = undefined

        querySearchCondition = {
          受注部所コード: userInfo.部所コード,
        }

        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      }
    }
  }, [gridInitialized, 受注部所isLoadEnded, comboBoxDataInitialized])

  useEffect(() => {
    document.title = `海コン受注配車パターン一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">海コン受注配車パターン一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-120rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="input-group">
                                <ComboBox.Busyo
                                  placeholder="受注部所"
                                  itemsSource={部所ItemSource}
                                  isAllSelect={false}
                                  isLoadEnded={受注部所isLoadEnded}
                                  setIsLoadEnded={set受注部所isLoadEnded}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  isRequired={true}
                                  setSelectedValue={(v) => {
                                    set受注部所コード(v)
                                  }}
                                  selectedValue={受注部所コード}
                                  ComboBox={受注部所ComboBox}
                                  setComboBox={
                                    set受注部所ComboBox
                                  }></ComboBox.Busyo>
                              </div>
                            </div>
                            <div className="search-condition-row">
                              <div className="input-group">
                                <TextInput
                                  style={{ width: "6rem" }}
                                  id="荷主コード"
                                  name="荷主コード"
                                  value={荷主コード}
                                  setValue={set荷主コード}
                                  onBlur={async (e) => {
                                    const v = e.currentTarget.value
                                    set表紙(v)
                                  }}
                                  maxLength={5}
                                  placeholder="荷主CD"
                                />
                                <TextInput
                                  id="荷主名"
                                  name="荷主名"
                                  value={荷主略称1}
                                  setValue={set荷主略称1}
                                  maxLength={100}
                                  placeholder="荷主略称"
                                />
                              </div>
                              <ComboBox.HyosiBunkatu
                                placeholder="表紙名"
                                isAllSelect={true}
                                isReadOnly={
                                  表紙分割ItemSource == null ||
                                  表紙分割ItemSource.length <= 0
                                    ? true
                                    : false
                                }
                                itemsSource={表紙分割ItemSource}
                                isLoadEnded={表紙分割IsLoadEnded}
                                lostFocus={(control) => {
                                  if (control.selectedValue == null) return

                                  const ninusiSeikyuService =
                                    new NinusiSeikyuService()
                                  ninusiSeikyuService
                                    .getListUchiwake({
                                      荷主請求Id: control.selectedValue,
                                    })
                                    .then((res) => {
                                      res.data &&
                                        res.data.length > 0 &&
                                        set請求内訳ItemSource([...res.data])
                                    })
                                }}
                                setIsLoadEnded={set表紙分割IsLoadEnded}
                                setSelectedValue={(v) => {
                                  if (v === 0) {
                                    set荷主請求ID(undefined)
                                  } else {
                                    set荷主請求ID(v)
                                  }
                                }}
                                selectedValue={荷主請求ID}
                                ComboBox={表紙分割ComboBox}
                                setComboBox={
                                  set表紙分割ComboBox
                                }></ComboBox.HyosiBunkatu>
                              <ComboBox.SeikyuUtiwake
                                placeholder="請求内訳"
                                isAllSelect={true}
                                isReadOnly={
                                  請求内訳ItemSource == null ||
                                  請求内訳ItemSource.length <= 0
                                    ? true
                                    : false
                                }
                                itemsSource={請求内訳ItemSource}
                                isLoadEnded={請求内訳IsLoadEnded}
                                setIsLoadEnded={set請求内訳IsLoadEnded}
                                setSelectedValue={(v) => {
                                  if (v === 0) {
                                    set荷主請求内訳ID(undefined)
                                  } else {
                                    set荷主請求内訳ID(v)
                                  }
                                }}
                                selectedValue={荷主請求内訳ID}
                                ComboBox={請求内訳ComboBox}
                                setComboBox={
                                  set請求内訳ComboBox
                                }></ComboBox.SeikyuUtiwake>
                              <div className="input-group">
                                <TextInput
                                  id="作業場所社名"
                                  name="作業場所社名"
                                  value={社名}
                                  setValue={set社名}
                                  maxLength={100}
                                  placeholder="社名・ヤード"
                                />
                                <TextInput
                                  id="作業場所地名"
                                  name="作業場所地名"
                                  value={地名}
                                  setValue={set地名}
                                  maxLength={100}
                                  placeholder="地名"
                                />
                              </div>
                              <TextInput
                                id="受注配車パターンコード"
                                name="受注配車パターンコード"
                                value={受注配車パターンコード}
                                setValue={set受注配車パターンコード}
                                maxLength={20}
                                placeholder="パターンコード"
                              />
                            </div>
                            <div className="search-condition-row">
                              <Button
                                type="submit"
                                disabled={isSearching}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  search()
                                }}>
                                <FontAwesomeIcon icon={faSearch} />
                                検索
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  gridInitializedHandler={gridInitializedHandler}
                  gridProperties={{
                    frozenColumns: 6,
                  }}
                  headerComponent={
                    <Link
                      to={
                        util.getMenuPath(
                          メニューコード.海コン受注配車.海コン_受注パターン登録
                        )[0]
                      }
                      onClick={() =>
                        gridPageHelper.savePageConditionData(location.pathname)
                      }>
                      <Button disabled={isSearching}>
                        <FontAwesomeIcon icon={faPlusSquare} />
                        新規追加
                      </Button>
                    </Link>
                  }>
                  <wjrGrid.FlexGridColumn
                    header=" "
                    allowMerging="true"
                    align="center"
                    width={80}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKaikonZyutyuHaisyaPatternListGetRes>
                      ) => {
                        // 荷主登録
                        const url = util.getMenuPath(
                          メニューコード.海コン受注配車.海コン_受注パターン登録
                        )[1]
                        return (
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            onClick={() => {
                              // 画面全体のスクロール位置の保存
                              gridPageHelper.savePageConditionData(
                                location.pathname
                              )
                              history.push(
                                url.replaceAll(
                                  ":id",
                                  context.item.受注配車パターンID!.toString()
                                )
                              )
                            }}>
                            編集
                          </Button>
                        )
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="受注配車パターンコード"
                    width={128}
                    header="パターンCD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="受注配車パターン名"
                    width={200}
                    header="パターン名"></wjrGrid.FlexGridColumn>
                  {/* 荷主 */}
                  <wjrGrid.FlexGridColumn
                    binding="荷主コード"
                    width={80}
                    header="荷主CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="荷主略称1"
                    width={200}
                    isReadOnly
                    header="荷主名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="表紙名"
                    width={128}
                    header="表紙名"></wjrGrid.FlexGridColumn>
                  {/* コンテナ情報 */}
                  <wjrGrid.FlexGridColumn
                    binding="コンテナサイズ名称1"
                    width={80}
                    header="サイズ"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="コンテナ軸名称1"
                    width={80}
                    header="軸"></wjrGrid.FlexGridColumn>
                  {/* PICK */}
                  <wjrGrid.FlexGridColumn
                    binding="PICK積卸先コード"
                    header="積卸先CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK積卸先名称"
                    header="社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK積卸先市区町村"
                    header="地名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK運行部所コード"
                    dataMap={運行部所DataMap}
                    header="運行部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK乗務員売上額"
                    format="n0"
                    cssClass="number-col"
                    header="乗務員売上額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK海コン付帯高速料"
                    format="n0"
                    cssClass="number-col"
                    header="付帯高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK付帯作業区分名称1"
                    header="付帯作業分類"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK付帯作業手当"
                    format="n0"
                    cssClass="number-col"
                    header="付帯手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="PICK工程備考"
                    format="n0"
                    cssClass="number-col"
                    header="工程備考"></wjrGrid.FlexGridColumn>
                  {/* 作業 */}
                  <wjrGrid.FlexGridColumn
                    binding="作業積卸先コード"
                    header="積卸先CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業積卸先名称"
                    header="社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業積卸先市区町村"
                    header="地名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業運行部所コード"
                    dataMap={運行部所DataMap}
                    header="運行部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業乗務員売上額"
                    format="n0"
                    cssClass="number-col"
                    header="乗務員売上額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業海コン付帯高速料"
                    format="n0"
                    cssClass="number-col"
                    header="付帯高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業付帯作業区分名称1"
                    header="付帯作業分類"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業付帯作業手当"
                    format="n0"
                    cssClass="number-col"
                    header="付帯手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="作業工程備考"
                    format="n0"
                    cssClass="number-col"
                    header="工程備考"></wjrGrid.FlexGridColumn>

                  {/* 返却 */}
                  <wjrGrid.FlexGridColumn
                    binding="返却積卸先コード"
                    header="積卸先CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却積卸先名称"
                    header="社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却積卸先市区町村"
                    header="地名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却運行部所コード"
                    dataMap={運行部所DataMap}
                    header="運行部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却乗務員売上額"
                    format="n0"
                    cssClass="number-col"
                    header="乗務員売上額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却海コン付帯高速料"
                    format="n0"
                    cssClass="number-col"
                    header="付帯高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却付帯作業区分名称1"
                    header="付帯作業分類"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却付帯作業手当"
                    format="n0"
                    cssClass="number-col"
                    header="付帯手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="返却工程備考"
                    format="n0"
                    cssClass="number-col"
                    header="工程備考"></wjrGrid.FlexGridColumn>

                  {/* その他 */}
                  <wjrGrid.FlexGridColumn
                    binding="その他積卸先コード"
                    header="積卸先CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他積卸先名称"
                    header="社名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他積卸先市区町村"
                    header="地名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他運行部所コード"
                    dataMap={運行部所DataMap}
                    header="運行部所"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他乗務員売上額"
                    format="n0"
                    cssClass="number-col"
                    header="乗務員売上額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他海コン付帯高速料"
                    format="n0"
                    cssClass="number-col"
                    header="付帯高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他付帯作業区分名称1"
                    header="付帯作業分類"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他付帯作業手当"
                    format="n0"
                    cssClass="number-col"
                    header="付帯手当"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="その他工程備考"
                    format="n0"
                    cssClass="number-col"
                    header="工程備考"></wjrGrid.FlexGridColumn>
                  {/* 請求 */}
                  <wjrGrid.FlexGridColumn
                    binding="請求内訳名"
                    header="請求内訳"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求運送料課税区分コード"
                    dataMap={課税区分DataMap}
                    header="非/課"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求運送料"
                    format="n0"
                    cssClass="number-col"
                    header="運送料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求付帯料課税区分コード"
                    dataMap={課税区分DataMap}
                    header="非/課"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求付帯料"
                    format="n0"
                    cssClass="number-col"
                    header="付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求高速料税込区分コード"
                    dataMap={税込区分DataMap}
                    isReadOnly={true}
                    header="込/抜"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求高速料"
                    format="n0"
                    cssClass="number-col"
                    header="高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求合計"
                    format="n0"
                    cssClass="number-col"
                    isReadOnly={true}
                    header="請求合計"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="計上基準日区分名称1"
                    isReadOnly={true}
                    header="請求基準日"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="請求備考"
                    width={150}
                    header="請求備考"></wjrGrid.FlexGridColumn>
                  {/* 支払 */}
                  <wjrGrid.FlexGridColumn
                    binding="支払運送料"
                    format="n0"
                    cssClass="number-col"
                    header="運送料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払付帯料"
                    cssClass="number-col"
                    header="付帯料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払高速料"
                    format="n0"
                    cssClass="number-col"
                    header="高速料"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払合計"
                    format="n0"
                    cssClass="number-col"
                    header="支払合計"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="支払備考"
                    width={150}
                    header="支払備考"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* 荷主検索 */}
      <NinusiSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主略称1(荷主.荷主名)
        }}></NinusiSearchModal>
    </>
  )
}

export default KaikonZyutyuHaisyPatternList
